/*eslint unicode-bom: ["error", "always"]*/
import styles from "./access.module.css";
import React, { useEffect } from 'react';
import Spacer from "components/layout/Spacer";
import { NavLink, useNavigate } from 'react-router';

function NoAccess() {

    const navigate = useNavigate();

    // Initialize function
    useEffect(() => {
        const redirectTimer = setInterval(() => navigate('/'), 15000); // Navigate to frontpage after 15 seconds

        return () => {
            clearInterval(redirectTimer);
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigate]);

    return (
         <div className={styles.noAccess}>
            <div className={styles.noAccessTitle}>Oops...!</div>
            <div>
                <p>
                    Du har ikke tilgang til modulen.
                </p>
                <p>
                    Vennligst ta kontakt med administrator.
                </p>
            </div>
            <Spacer />
            <div className="k-text-center">
                Klikk <NavLink to="/">her</NavLink>  for å gå navigere til forsiden.
            </div>
        </div>
    );
}

export default NoAccess;
